export interface Task {
  state: 'upComing' | 'inProgress' | 'completed' | 'failed' | 'skipped';
  description: string;
  guidance?: string;
  media?: string;
  mediaLeft?: string;
  info?: string;
  identifier: string;
  time: number;
  start?: boolean;
  end?: boolean;
  button?: boolean;
  measureMetrics?: boolean;
}
